import { LayoutProvider } from "../common/layout/layout-provider";
import { PageHeader } from "../common/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProductsTabContent } from "./products-tab-content";
import { CategoriesTabContent } from "./categories-tab-content";
import { BrandsTabContent } from "./brands-tab-content";

export function ProductsPage() {
  return (
    <div>
      <PageHeader title="Manage Products" />
      <LayoutProvider>
        <Tabs defaultValue="products">
          <TabsList className="bg-neutral-50 border-b-2 border-border rounded-none w-full p-0 h-auto justify-start">
            <TabsTrigger
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
              value="products"
            >
              Products
            </TabsTrigger>
            <TabsTrigger
              value="categories"
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
            >
              Categories
            </TabsTrigger>
            <TabsTrigger
              value="brands"
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
            >
              Brands
            </TabsTrigger>
          </TabsList>
          <TabsContent value="products">
            <ProductsTabContent />
          </TabsContent>
          <TabsContent value="categories">
            <CategoriesTabContent />
          </TabsContent>
          <TabsContent value="brands">
            <BrandsTabContent />
          </TabsContent>
        </Tabs>
      </LayoutProvider>
    </div>
  );
}
